import React from "react";
import { FaExclamationTriangle, FaRedo } from "react-icons/fa";
import styles from "./FeedErrorBoundary.module.css";
import {
  isChunkLoadError,
  reloadOnceForChunkError,
  reloadPage,
  reportRenderError,
} from "../../utils/renderCrash";

class FeedErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    reportRenderError(error, errorInfo, "FeedErrorBoundary");
    reloadOnceForChunkError(error);
  }

  handleRetry = () => {
    if (isChunkLoadError(this.state.error)) {
      reloadPage();
      return;
    }
    this.setState({ hasError: false, error: null });
    // Let parent decide how to recover (e.g. refetch)
    if (this.props.onRetry) {
      this.props.onRetry();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.errorState} role="alert">
          <FaExclamationTriangle className={styles.errorIcon} aria-hidden="true" />
          <h3>Something went wrong</h3>
          <p>We couldn't load the feed. Please try again.</p>
          <button
            type="button"
            onClick={this.handleRetry}
            className={styles.retryButton}
          >
            <FaRedo aria-hidden="true" /> Try again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default FeedErrorBoundary;